import React from 'react';
import { Navbar, Container, NavbarBrand, Row, Col, NavbarToggler, Collapse, Nav, NavItem, NavLink, NavbarText } from 'reactstrap';

class Navigation extends React.Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = {
            isOpen: false,
        };
    }
    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }
    render() {
        return (
            <Navbar expand="sm" className="menu" color="dark">
                <Container>
                    <NavbarBrand><img src={require("assets/img/SPRegula.png")} style={{ height: "7vh" }} /></NavbarBrand>
                    <NavbarBrand><img src={require("assets/img/logo-prefeitura.png")} style={{ height: "7vh" }} /></NavbarBrand>
                </Container>
            </Navbar>
        );
    }
}
export default Navigation;